import React from "react";
import { ago } from "@/lib/mongoMcp";

const TONE = { passed: "text-emerald-300 border-emerald-400/30", failed: "text-red-300 border-red-400/30" };

export default function BuildCheckHistory({ history }) {
    if (!history?.length) return null;
    return (
        <div className="bg-[#0a0a0a] border border-white/10 rounded-md" data-testid="build-check-history">
            <div className="px-4 py-2.5 border-b border-white/10 text-[10px] uppercase tracking-wider text-white/40">Recent runs</div>
            <ul className="divide-y divide-white/5">
                {history.map((h, i) => (
                    <li key={`${h.started_at}-${i}`} className="px-4 py-2 flex items-center gap-3 text-[11px]" data-testid={`build-check-history-${i}`}>
                        <span className={`text-[9px] uppercase tracking-wider px-2 py-0.5 rounded-full border ${TONE[h.state] || "text-white/50 border-white/15"}`}>{h.state}</span>
                        <span className="font-mono text-white/50 w-24">{ago(h.finished_at || h.started_at)}</span>
                        <span className="font-mono text-white/35 w-16">{h.trigger}</span>
                        <span className="text-white/60 truncate flex-1 min-w-0">{h.failed?.length ? h.failed.join(" · ") : "all checks passed"}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
